import { Attachment, FileType, Stream } from '@/library/types/files';

export const rotateDirectionEnums = {
  top: '0deg',
  right: '90deg',
  bottom: '180deg',
  left: '270deg'
} as const;

const OFFICE_PREVIEW_PREFIX = 'https://view.officeapps.live.com/op/view.aspx?src=';
const INLINE_PREVIEW_TYPES = new Set<FileType>(['pdf', 'txt']);

export const PREVIEWABLE_FILE_TYPES = new Set<FileType>([
  'image',
  'doc',
  'pdf',
  'spreadsheets',
  'txt'
]);

export const isAttachment = (stream: Stream): stream is Attachment =>
  stream !== null && (stream as Attachment).url_inline !== undefined;

export const isAbsoluteHttpUrl = (url?: string | null): url is string =>
  typeof url === 'string' && /^https?:\/\//i.test(url);

export const getDocumentPreviewSrc = (
  fileType: string,
  file: Pick<Attachment, 'url_inline' | 'url_encoded'>,
  baseUrl = ''
): string | null => {
  if (INLINE_PREVIEW_TYPES.has(fileType as FileType)) {
    if (!file.url_inline) return null;

    const src = `${baseUrl}${file.url_inline}`;

    return isAbsoluteHttpUrl(src) ? src : null;
  }

  if (!isAbsoluteHttpUrl(file.url_encoded)) return null;

  return `${OFFICE_PREVIEW_PREFIX}${file.url_encoded}`;
};

export const getImagePreviewSrc = (url?: string | null, baseUrl = ''): string | null => {
  if (!url) return null;

  const src = `${baseUrl}${url}`;

  return isAbsoluteHttpUrl(src) ? src : null;
};
